import { setClassIf } from '@/scripts/utils/base';
import Events from '@/scripts/lib/Events';
import LikesStorage from './LikesStorage';

export default class LikeBtn {
   events = new Events();

   /** 
    * @param {HTMLElement} root 
    * @param {LikesStorage} storage
    */
   constructor(root, storage) {
      this.$root = root;
      this._storage = storage;
      this._init();
   }

   _init() {
      this._getElements();
      this._initEvents();

      this._updateValue();
      this._updateTotal();
   }

   _initEvents() {
      this.$root.addEventListener('click', () => {
         this._storage.rev();
      });

      this._storage.events.addListener('change', () => {
         this._updateValue();
      });

      this._storage.events.addListener('total', () => {
         this._updateTotal();
      });

      this._storage.events.addListener('disable', () => {
         this.$root.disabled = this._storage.disabled;
      });
   }

   _updateValue() {
      setClassIf(this.$root, 'like-btn__liked', this._storage.value);
   }

   _updateTotal() {
      this.$text.innerHTML = this._formatTotal(this._storage.total);
      setClassIf(this.$root, 'like-btn__no-likes', !this._storage.total);
   }

   _formatTotal(value) {
      if (value < 1e3) return `${value}`;
      if (value < 1e6) return `${Math.round(value / 1e3)}k`;
      return `${Math.round(value * 10 / 1e6) / 10}M`;
   }

   _getElements() {
      this.$text = this.$root.querySelector('.like-btn-text-js');
   }

}